export type CreditDeposit = {
  id: number;
  companyId: number;
  amount: number;
  reference: string;
  createdAt?: string;
  status?: DepositStatus;
};

export type CreditDepositInput = Omit<
  CreditDeposit,
  "id" | "createdAt" | "status"
>;

export enum DepositStatus {
  Undefined = "Undefined",
  Created = "Created",
  Approved = "Approved",
  Failed = "Failed",
  Cancelled = "Cancelled",
}

export enum WithdrawalStatus {
  Undefined = "Undefined",
  Created = "Created",
  Paid = "Paid",
  Failed = "Failed",
}

export type StatusType = DepositStatus | WithdrawalStatus;

export type CreditWithdrawal = {
  id: number;
  companyId: number;
  amount: number;
  reference: string;
  status: WithdrawalStatus;
  withdrawalBy: number;
  soruceType: string;
  soruceId: number;
  createdAt: string;
  updatedAt: string;
};

export type CreditTabType = "deposits" | "withdrawals";